import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/sgtec/uabs/pagamentos?situacao=${filtro.situacao}&status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/pagamentos/anexos/${pagamentoAnexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarReprovarPagamento(aprovaReprovaPagamentoDto) {
        return axiosJwt
            .post(
                `${api}/sgtec/uabs/pagamentos/aprovar`,
                aprovaReprovaPagamentoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportar(id) {
        let url = `${api}/sgtec/uabs/pagamentos/${id}/exportar`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/pagamentos/${pagamentoId}/historico`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCertidoes(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/sgtec/uabs/pagamentos/${pagamentoId}/certidoes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportar(pagamentoId) {
        let url = `${api}/sgtec/uabs/pagamentos/${pagamentoId}/exportar`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/sgtec/uabs/pagamentos/${pagamentoId}/anexos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/sgtec/uabs/pagamentos/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoId', pagamentoAnexo.tipoId)
        formData.append('descritivo', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)

        return axiosJwt
            .post(
                `${api}/sgtec/uabs/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/sgtec/uabs/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    definirPrioritario(pagamentoId) {
        return axiosJwt
            .patch(
                `${api}/sgtec/uabs/pagamentos/${pagamentoId}/prioritario`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    definirEspecial(pagamentoId) {
        return axiosJwt
            .patch(
                `${api}/sgtec/uabs/pagamentos/${pagamentoId}/especial`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    retornarPagamento(pagamentoId) {
        return axiosJwt
            .patch(`${api}/sgtec/uabs/pagamentos/${pagamentoId}/retornaruabs`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterCategoriasReprovacao() {
        return axiosJwt
            .get(`${api}/sgtec/uabs/pagamentos/reprovarpagamentoopcoes`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterCategoriasAprovacaoJustificada() {
        return axiosJwt
            .get(`${api}/sgtec/uabs/pagamentos/aprovacaojustificadaopcoes`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    // Métodos para Notas Fiscais
    obterNotasFiscais(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/pagamentos/${pagamentoId}/notasfiscais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoNotaFiscal(pagamentoNotaFiscalId) {
        return axiosJwt
            .get(
                `${api}/sgtec/uabs/pagamentos/notasfiscais/${pagamentoNotaFiscalId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoNotaFiscal(pagamentoNotaFiscal) {
        // Separar o arquivo do resto dos dados
        const arquivo = pagamentoNotaFiscal.anexoNotaFiscal
        
        // Criar o DTO sem o arquivo
        const notaFiscalDto = {
            pagamentoId: pagamentoNotaFiscal.pagamentoId,
            tipo: pagamentoNotaFiscal.tipo,
            numeroNota: pagamentoNotaFiscal.numeroNota,
            dataEmissao: pagamentoNotaFiscal.dataEmissao,
            mesCompetencia: pagamentoNotaFiscal.mesCompetencia,
            valorNota: pagamentoNotaFiscal.valorNota,
            localPrestacao: pagamentoNotaFiscal.localPrestacao,
            servicoPorSocio: pagamentoNotaFiscal.servicoPorSocio,
            
            // Dados do Prestador
            prestadorCnpjCpf: pagamentoNotaFiscal.prestadorCnpjCpf,
            prestadorInscricaoMunicipal: pagamentoNotaFiscal.prestadorInscricaoMunicipal,
            prestadorRazaoSocial: pagamentoNotaFiscal.prestadorRazaoSocial,
            prestadorNomeFantasia: pagamentoNotaFiscal.prestadorNomeFantasia,
            prestadorOptanteSimples: pagamentoNotaFiscal.prestadorOptanteSimples,
            prestadorTelefone: pagamentoNotaFiscal.prestadorTelefone,
            prestadorEndereco: pagamentoNotaFiscal.prestadorEndereco,
            
            // Dados do Tomador
            tomadorCnpjCpf: pagamentoNotaFiscal.tomadorCnpjCpf,
            tomadorRazaoSocial: pagamentoNotaFiscal.tomadorRazaoSocial,
            tomadorEmail: pagamentoNotaFiscal.tomadorEmail,
            tomadorTelefone: pagamentoNotaFiscal.tomadorTelefone,
            tomadorEndereco: pagamentoNotaFiscal.tomadorEndereco,
            
            // Valores
            valorServico: pagamentoNotaFiscal.valorServico,
            valorDeducao: pagamentoNotaFiscal.valorDeducao,
            valorIss: pagamentoNotaFiscal.valorIss,
            valorPis: pagamentoNotaFiscal.valorPis,
            valorCofins: pagamentoNotaFiscal.valorCofins,
            valorInss: pagamentoNotaFiscal.valorInss,
            valorIr: pagamentoNotaFiscal.valorIr,
            valorCsll: pagamentoNotaFiscal.valorCsll,
            
            // Alíquotas
            aliquotaIss: pagamentoNotaFiscal.aliquotaIss,
            aliquotaPis: pagamentoNotaFiscal.aliquotaPis,
            aliquotaCofins: pagamentoNotaFiscal.aliquotaCofins,
            aliquotaInss: pagamentoNotaFiscal.aliquotaInss,
            aliquotaIr: pagamentoNotaFiscal.aliquotaIr,
            aliquotaCsll: pagamentoNotaFiscal.aliquotaCsll,
            
            // Outros campos
            codigoAtividade: pagamentoNotaFiscal.codigoAtividade,
            descricaoAtividade: pagamentoNotaFiscal.descricaoAtividade,
            cosServico: pagamentoNotaFiscal.cosServico,
            descricaoServico: pagamentoNotaFiscal.descricaoServico,
            descricaoNota: pagamentoNotaFiscal.descricaoNota
        }

        // Criar FormData apenas com o DTO e o arquivo
        const formData = new FormData()
        formData.append('notaFiscal', JSON.stringify(notaFiscalDto))
        if (arquivo) {
            formData.append('anexoNotaFiscal', arquivo)
        }

        return axiosJwt
            .post(
                `${api}/sgtec/uabs/pagamentos/${pagamentoNotaFiscal.pagamentoId}/notasfiscais`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
